import * as React from 'react';
import { NavLink } from 'reactstrap';
import { ROUTE_PATH } from '../../../constants';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../../reducers/session';

export const SingleTicketViewLink = (props: {
  id: number | string;
  children?: React.ReactNode;
}) => {
  const { id, children, ...rest } = props;
  const orgID = useSelector(sessionSelector.getRiskID);
  const orgIDParam = orgID ? `?id=${orgID}` : '';
  return (
    <NavLink
      href={`${ROUTE_PATH.DASHBOARD.UNIFIED}/tickets/${id}${orgIDParam}`}
      target="_blank"
      rel="noreferrer"
      className="px-1"
      {...rest}
    >
      {children || `#${id}`}
    </NavLink>
  );
};
